/* eslint-disable @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call */
import { container } from '@/container';
import { Signalr } from '@/services/signalr/Signalr';

interface SignalrHandler {
  methodNames: string[],
  hubConnection: boolean;
}

const signalrMessageHandlers = Symbol('signalrMessageHandlers');
const signalr = container.get(Signalr);

export function SignalrListener<T extends (new(...args: any[]) => any)>(SignalrBase: T) {
  return class extends SignalrBase {
    constructor(...args: any[]) {
      super(...args);
      const subMethods: SignalrHandler[] = SignalrBase.prototype[signalrMessageHandlers];
      if (subMethods) {
        subMethods.forEach(({ methodNames, hubConnection }, property: keyof typeof this) => {
          const cb = this[property];
          if (typeof cb !== 'function') {
            throw new TypeError(`Unable to bind Signalr handler(s) "${methodNames.join('", "')}" to class method: ${String(property)}`);
          }

          methodNames?.forEach((methodName) => {
            // Register handler directly to HubConnection (raw message, not processed).
            if (hubConnection) {
              signalr.hubConnection.on(methodName, cb.bind(this));
            }
            // Otherwise, register handler on the service directly.
            else {
              signalr.on(methodName, cb.bind(this));
            }
          });
        });
      }
    }
  };
}

export function SignalrHubConnectionMessage(...methodNames: string[]) {
  return function (target: any, propertyKey: string) {
    target[signalrMessageHandlers] = target[signalrMessageHandlers] || new Map<string, string[]>();
    target[signalrMessageHandlers].set(propertyKey, { methodNames, hubConnection: true });
  };
}

export function SignalrMessage(...methodNames: string[]) {
  return function (target: any, propertyKey: string) {
    target[signalrMessageHandlers] = target[signalrMessageHandlers] || new Map<string, string[]>();
    target[signalrMessageHandlers].set(propertyKey, { methodNames, hubConnection: false });
  };
}
